import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import Slider from "react-slick";
import "swiper/css";
import { FaChevronRight } from "react-icons/fa";
import { FaChevronLeft } from "react-icons/fa";
import "swiper/css/pagination";
import "./TestimonialsSlider.css"; // Import CSS file
import { useState,useEffect } from "react";
const TestimonialSlider = () => {
  const CustomPrevArrow = (props) => {
    const { onClick } = props;
    return (
      <div className="custom-arrow1 custom-prev1" onClick={onClick}>
        <FaChevronLeft size={30} color="white" />
      </div>
    );
  };

  const CustomNextArrow = (props) => {
    const { onClick } = props;
    return (
      <div className="custom-arrow1 custom-next1" onClick={onClick}>
        <FaChevronRight  size={30} color="white"/>
      </div>
    );
  };
  var settings2 = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    cssEase: "linear",
    nextArrow: <CustomNextArrow  />,
    prevArrow: <CustomPrevArrow />,
  };
  const testimonialsen = [
    {
      
      image: "/assets/img/testimonials/client-1.jpg",
      review: "I was struggling with stubborn stains and hard scales on my bathroom taps and faucets until I tried TerraClenz™ SS Cleaner. With just a few sprays, the transformation was incredible—my taps looked as good as new! Highly effective and easy to use, this cleaner truly delivers on its promise.",
    },
    {
     
      image: "/assets/img/testimonials/client-2.jpg",
      review: "I used to struggle with sticky floors and an unpleasant odor after using other brand floor cleaners. But after trying TerraClenz™ Floor Cleaner, the difference was amazing! My floors felt completely non-sticky, the fragrance was refreshing, and, as promised, no flies were attracted. A truly effective and reliable cleaner!",
    },
    {
  
      image: "/assets/img/testimonials/client-4.jpg",
      review: "Our laptops and gadgets had stubborn marks and stains from regular use. After spraying just a few drops of TerraClenz™ Gadget Cleaner and wiping with a soft cloth, they looked spotless and felt as good as new! An excellent cleaner for keeping gadgets fresh and pristine.",
    },
    {
    
      image: "/assets/img/testimonials/client-3.jpg",
      review: "With other brand toilet cleaners, the strong, unbearable smell made cleaning difficult—we even had to wear masks! But with TerraClenz™ Toilet Cleaner, there was no harsh chemical odor, allowing us to breathe comfortably while cleaning. Despite being gentle, its cleaning power was remarkable and delivered excellent results!",
    },
  
  ];
  const testimonialshi = [
    {
      image: "/assets/img/testimonials/client-1.jpg",
      review: "मैं अपने बाथरूम के नल और फॉसेट्स पर जमी हुई गंदगी और दागों से परेशान था। लेकिन जब मैंने टेरा क्लेंज़™ SS क्लीनर का उपयोग किया, तो सिर्फ कुछ स्प्रे के बाद ही वे नए जैसे चमक उठे! यह अत्यधिक प्रभावी और उपयोग में आसान क्लीनर है।",
    },
    {
      image: "/assets/img/testimonials/client-2.jpg",
      review: "दूसरे ब्रांड के फ्लोर क्लीनर इस्तेमाल करने के बाद फर्श चिपचिपा और बदबूदार हो जाता था। लेकिन जब मैंने टेरा क्लेंज़™ फ्लोर क्लीनर आज़माया, तो परिणाम चौंकाने वाले थे! फर्श बिल्कुल साफ, सुगंधित, और सबसे अच्छी बात—इससे मक्खियाँ आकर्षित नहीं हुईं।",
    },
    {
      image: "/assets/img/testimonials/client-4.jpg",
      review: "हमारे लैपटॉप और गैजेट्स पर नियमित इस्तेमाल से जिद्दी दाग लग गए थे। लेकिन सिर्फ कुछ बूंदें टेरा क्लेंज़™ गैजेट क्लीनर छिड़कने और सॉफ्ट कपड़े से पोंछने के बाद, वे नए जैसे दिखने लगे! गैजेट्स को साफ और नया बनाए रखने के लिए यह एक बेहतरीन क्लीनर है।",
    },
    {
      image: "/assets/img/testimonials/client-3.jpg",
      review: "दूसरे ब्रांड के टॉयलेट क्लीनर्स में तेज़ गंध होती थी, जिससे सफाई करना मुश्किल हो जाता था—हमें मास्क पहनना पड़ता था! लेकिन टेरा क्लेंज़™ टॉयलेट क्लीनर में कोई तेज़ रासायनिक गंध नहीं थी, जिससे सफाई के दौरान आराम से सांस ले सके। फिर भी, इसकी सफाई करने की शक्ति बेहतरीन थी!",
    },
  ];
  const testimonialste = [
    {
      image: "/assets/img/testimonials/client-1.jpg",
      review: "నా బాత్రూమ్ ట్యాప్స్ మరియు ఫాసెట్స్ పై మచ్చలు, హార్డ్ స్కేల్స్ తొలగించడంలో చాలా కష్టపడ్డాను. కానీ టెర్రాక్లెంజ్™ SS క్లీనర్ ఉపయోగించిన తర్వాత, కేవలం కొన్ని స్ప్రేలు చేసినా అవి కొత్తలా మెరుస్తున్నాయి! చాలా ప్రభావవంతమైనది మరియు సులభంగా ఉపయోగించగలిగేది.",
    },
    {
      image: "/assets/img/testimonials/client-2.jpg",
      review: "ఇతర బ్రాండ్స్ ఫ్లోర్ క్లీనర్స్ ఉపయోగించినప్పుడు నేలలు అంటిపెట్టుకుని ఉండేవి, దుర్వాసన ఉండేది. కానీ టెర్రాక్లెంజ్™ ఫ్లోర్ క్లీనర్ వాడిన తర్వాత, అది పూర్తిగా తేడా చూపించింది! నేలలు గ్లాసీగా, మృదువుగా మారాయి, సువాసన వచ్చింది, ఇకపై ఈగలు కూడా ఆకర్షితం కాలేదు.",
    },
    {
      image: "/assets/img/testimonials/client-4.jpg",
      review: "మన ల్యాప్‌టాప్‌లు, గాడ్జెట్‌లు రోజువారీ వాడకం వల్ల మచ్చలు మరియు మరకలు ఏర్పడతాయి. కానీ టెర్రాక్లెంజ్™ గాడ్జెట్ క్లీనర్ కొన్ని చుక్కలు వేసి, మృదువైన గుడ్డతో తుడిచిన తర్వాత, అవి కొత్తలా కనిపించాయి! గాడ్జెట్‌లను శుభ్రంగా మరియు నూతనంగా ఉంచేందుకు అద్భుతమైన క్లీనర్.",
    },
    {
      image: "/assets/img/testimonials/client-3.jpg",
      review: "ఇతర బ్రాండ్ టాయిలెట్ క్లీనర్స్ ఉపయోగించినప్పుడు భయంకరమైన వాసన రావడం వల్ల మేము మాస్క్ ధరించాల్సి వచ్చేది! కానీ టెర్రాక్లెంజ్™ టాయిలెట్ క్లీనర్‌తో, ఎటువంటి తీవ్రమైన రసాయన వాసన లేదు, శుభ్రం చేయేటప్పుడు సులభంగా శ్వాస తీసుకోవచ్చు. అది చాలా సాఫ్ట్ అయినప్పటికీ, శుభ్రం చేయడంలో అద్భుతంగా పని చేసింది!",
    },
  ];
  const testimonialsta = [
    {
      image: "/assets/img/testimonials/client-1.jpg",
      review: "என் குளியலறை குழாய்கள் மற்றும் சொட்டுநீர்க் குழாய்களில் கடினமான அழுக்கு மற்றும் பூஞ்சு இருந்தது. ஆனால், டெர்ராக்லென்ஸ்™ SS கிளீனர் பயன்படுத்திய பிறகு, சில ஸ்ப்ரேகளில் அவை புது போல மின்னின! மிகுந்த பயனுள்ள மற்றும் எளிதாக பயன்படுத்தக்கூடிய கிளீனர்.",
    },
    {
      image: "/assets/img/testimonials/client-2.jpg",
      review: "மற்ற பிராண்டுகளின் தரையில் ஒட்டும் உணர்வும், தீவிரமான வாசனையும் இருந்தன. ஆனால் டெர்ராக்லென்ஸ்™ தரை கிளீனர் பயன்படுத்திய பிறகு, தரை ஒரு முற்றிலும் புதிய அனுபவமாக உணர்ந்தது! ஒட்டாமல், பசுமையாகவும், நல்ல மணம் மாறியதும் மிக நல்ல அனுபவம்.",
    },
    {
      image: "/assets/img/testimonials/client-4.jpg",
      review: "எங்கள் லேப்டாப் மற்றும் சாதனங்களில் தினசரி பயன்பாட்டால் அழுக்கு மற்றும் புள்ளிகள் இருந்தன. ஆனால் டெர்ராக்லென்ஸ்™ காஜெட் கிளீனர் சில சொட்டு தூவி, மென்மையான துணியால் துடைத்த பிறகு, அவை புதிதாக மின்னின! சாதனங்களை சுத்தமாக வைக்க உதவும் சிறந்த கிளீனர்.",
    },
    {
      image: "/assets/img/testimonials/client-3.jpg",
      review: "மற்ற பிராண்டுகளின் கழிவறை கிளீனர்கள் கடுமையான மணம் காரணமாக சுத்தம் செய்ய மிகவும் கடினமாக இருந்தது, நாம் முகமூடி அணிய வேண்டிய நிலை! ஆனால் டெர்ராக்லென்ஸ்™ கழிவறை கிளீனர் எந்த மோசமான மணமுமின்றி, சுத்தம் செய்யும் போது சுகமாக இருந்தது. அதே நேரத்தில், அதன் சுத்தம் செய்யும் திறன் மிக சிறப்பு!",
    },
  ];
  const testimonialska = [
    {
      image: "/assets/img/testimonials/client-1.jpg",
      review: "ನಾನು ನನ್ನ ಸ್ನಾನಗೃಹದ ನಲ್ಲಿಗಳು ಮತ್ತು ನಲ್ಲಿಗಳ ಮೇಲಿನ ಮೊಂಡು ಕಲೆಗಳು ಮತ್ತು ಗಟ್ಟಿಯಾದ ಮಾಪಕಗಳೊಂದಿಗೆ ಹೋರಾಡುತ್ತಿದ್ದೆ, ಟೆರ್ರಾಕ್ಲೆನ್ಜ್™ ಎಸ್ಎಸ್ ಕ್ಲೀನರ್ ಅನ್ನು ಪ್ರಯತ್ನಿಸುವವರೆಗೂ. ಕೆಲವೇ ಸ್ಪ್ರೇಗಳೊಂದಿಗೆ, ಪರಿವರ್ತನೆ ನಂಬಲಾಗದಂತಿತ್ತು - ನನ್ನ ನಲ್ಲಿಗಳು ಹೊಸದಾಗಿ ಕಾಣುತ್ತಿದ್ದವು! ಹೆಚ್ಚು ಪರಿಣಾಮಕಾರಿ ಮತ್ತು ಬಳಸಲು ಸುಲಭ, ಈ ಕ್ಲೀನರ್ ನಿಜವಾಗಿಯೂ ತನ್ನ ಭರವಸೆಯನ್ನು ನೀಡುತ್ತದೆ",
    },
    {
      image: "/assets/img/testimonials/client-2.jpg",
      review: "ಇತರ ಬ್ರಾಂಡ್‌ನ ನೆಲದ ಕ್ಲೀನರ್‌ಗಳನ್ನು ಬಳಸಿದ ನಂತರ ನಾನು ಜಿಗುಟಾದ ನೆಲಗಳು ಮತ್ತು ದುರ್ವಾಸನೆಯು ಹಿಂಸಿಸುತ್ತಿತ್ತು. ಆದರೆ ಟೆರ್ರಾಕ್ಲೆನ್ಜ್™ ನೆಲದ ಕ್ಲೀನರ್ ಅನ್ನು ಪ್ರಯೋಗಿಸಿದ ನಂತರ, ವ್ಯತ್ಯಾಸ ಅಚ್ಚರಿ ತಂದಿತು! ನನ್ನ ನೆಲಗಳು ಸಂಪೂರ್ಣವಾಗಿ ಸ್ವಚ್ಛ, ಪರಿಮಳವು ಉಲ್ಲಾಸಕರವಾಗಿತ್ತು ಮತ್ತು ಭರವಸೆ ನೀಡಿದಂತೆ, ನೊಣಗಳು ಆಕರ್ಷಿತವಾಗಲಿಲ್ಲ. ನಿಜವಾಗಿಯೂ ಪರಿಣಾಮಕಾರಿ ಮತ್ತು ವಿಶ್ವಾಸಾರ್ಹ ಕ್ಲೀನರ್!",
    },
    {
      image: "/assets/img/testimonials/client-4.jpg",
      review: "ನಮ್ಮ ಲ್ಯಾಪ್‌ಟಾಪ್‌ಗಳು ಮತ್ತು ಗ್ಯಾಜೆಟ್‌ಗಳು ನಿಯಮಿತ ಬಳಕೆಯಿಂದ ಮೊಂಡು ಗುರುತುಗಳು ಮತ್ತು ಕಲೆಗಳನ್ನು ಹೊಂದಿದ್ದವು. ಟೆರ್ರಾಕ್ಲೆನ್ಜ್™ ಗ್ಯಾಜೆಟ್ ಕ್ಲೀನರ್‌ನ ಕೆಲವು ಹನಿಗಳನ್ನು ಸಿಂಪಡಿಸಿ ಮೃದುವಾದ ಬಟ್ಟೆಯಿಂದ ಒರೆಸಿದ ನಂತರ, ಅವು ಕಲೆಗಳಿಲ್ಲದೆ ಕಾಣುತ್ತಿದ್ದವು ಮತ್ತು ಹೊಸದಾಗಿರುವಂತೆ ಭಾಸವಾಗುತ್ತಿದ್ದವು! ಗ್ಯಾಜೆಟ್‌ಗಳನ್ನು ತಾಜಾ ಮತ್ತು ಶುಚಿಯಾಗಿಡಲು ಅತ್ಯುತ್ತಮ ಕ್ಲೀನರ್!",
    },
    {
      image: "/assets/img/testimonials/client-3.jpg",
      review: "ಇತರ ಬ್ರಾಂಡ್‌ನ ಟಾಯ್ಲೆಟ್ ಕ್ಲೀನರ್‌ಗಳೊಂದಿಗೆ, ಬಲವಾದ, ಅಸಹನೀಯ ವಾಸನೆಯು ಸ್ವಚ್ಛಗೊಳಿಸುವುದನ್ನು ಕಷ್ಟಕರವಾಗಿಸಿತು—ನಾವು ಮಾಸ್ಕ್ಗಳನ್ನು ಧರಿಸಬೇಕಾಯಿತು! ಆದರೆ ಟೆರ್ರಾಕ್ಲೆನ್ಜ್™ ಟಾಯ್ಲೆಟ್ ಕ್ಲೀನರ್‌ನೊಂದಿಗೆ, ಕಠಿಣ ರಾಸಾಯನಿಕ ವಾಸನೆ ಇರಲಿಲ್ಲ, ಸ್ವಚ್ಛಗೊಳಿಸುವಾಗ ನಾವು ಆರಾಮವಾಗಿ ಉಸಿರಾಡಲು ಅವಕಾಶ ನೀಡಿತು. ಮೃದುವಾಗಿದ್ದರೂ, ಅದರ ಸ್ವಚ್ಛಗೊಳಿಸುವ ಶಕ್ತಿಯು ಗಮನಾರ್ಹವಾಗಿತ್ತು ಮತ್ತು ಅತ್ಯುತ್ತಮ ಫಲಿತಾಂಶಗಳನ್ನು ನೀಡಿತು!",
    },
  ];
  const headen ={
    1:"What Our Customers Say"
  }
  const headka ={
    1:"ನಮ್ಮ ಗ್ರಾಹಕರು ಏನು ಹೇಳುತ್ತಾರೆ"
  }
  const headte ={
    1:"మా కస్టమర్స్ ఏమంటున్నారు"
  }
  const headta ={
    1:"எங்கள் வாடிக்கையாளர்கள் என்ன கூறுகிறார்கள்"
  }
  const headhi ={
    1:"हमारे ग्राहक क्या कहते हैं"
  }
   const [testimonials, setTestimonials] = useState(testimonialsen);
  
  const [head,setHead] = useState(headen)
    useEffect(() => {
      const storedLanguage = localStorage.getItem("selectedLanguage") || "en";
      switch (storedLanguage) {
        case "kn":
          setTestimonials(testimonialska);
          setHead(headka)
          break;
        case "te":
          setTestimonials(testimonialste);
          setHead(headte)
          break;
        case "ta":
          setTestimonials(testimonialsta);
          setHead(headta)
          break;
        case "hi":
          setTestimonials(testimonialshi);
          setHead(headhi)
          break;
        default:
          setTestimonials(testimonialsen);
      }
    }, []);
  return (
    <div className="testimonial-section">
      <h2 className="testimonial-title">{head[1]}</h2>
      <Slider {...settings2} className="test-slider">
        {testimonials.map((testimonial, index) => (
          <SwiperSlide key={index}>
            <div className="testimonial-card">
              {" "}
              {/* No border */}
              <img
                src={testimonial.image}
                alt={testimonial.name}
                className="testimonial-image"
                style={{display:"none"}}
              />
              <p className="review">"{testimonial.review}"</p>
              {/* <h4>- {testimonial.name}</h4> Only Name */}
            </div>
          </SwiperSlide>
        ))}
      </Slider>
    </div>
  );
};

export default TestimonialSlider;
